import type { HTMLAttributes, ReactNode } from 'react'

interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

function Panel({ children, className = '', ...rest }: PanelProps) {
  return (
    <div className={`grid gap-3 rounded-2xl border border-text-2/20 bg-text-2/10 p-3.5 ${className}`} {...rest}>
      {children}
    </div>
  )
}

export default Panel
